import { render, staticRenderFns } from "./EditorLegend.vue?vue&type=template&id=b91981b0&scoped=true&"
import script from "./EditorLegend.vue?vue&type=script&lang=js&"
export * from "./EditorLegend.vue?vue&type=script&lang=js&"
import style0 from "./EditorLegend.vue?vue&type=style&index=0&id=b91981b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91981b0",
  null
  
)

export default component.exports